var FinancialBlockDisplayMode={
  CalendarMode:"CalendarMode",
  FiscalMode:"FiscalMode"
}
export default FinancialBlockDisplayMode;
